export const CHECKOUT_ERROR_MESSAGES = {
  avsDown: 'We are experiencing an issue. Please double check your address(es).',
  avsBillingRejected:
    'We could not identify your billing address. Please check your Street Address and Zip Code.',
  avsShippingRejected:
    'We could not identify your shipping address. Please check your Street Address and Zip Code.',
  avsSavedRejected:
    'We could not identify your saved address. Please check your Street Address and Zip Code.',
  general: 'There was an issue processing your information. Please try again.',
  generalAddress:
    'There was an issue processing your address information. Please re-enter and try again.',
  noInventory:
    'There is no longer inventory available for an item in your order. Please return to your cart to edit your order.',
  paymentDeclined:
    'There was an issue processing your payment information. Please re-enter and try again.',
  pricesChangedSinglePage:
    'The pricing has changed from the time you started. Please refresh the page, re-confirm pricing, and re-enter your payment information',
  scorecardRequired: 'Please add a valid ScoreCard or remove what you have entered.',
  shippingRestriction:
    'Due to shipping restrictions, some products in your shopping cart cannot be shipped to the address you provided',
  noCheckoutKey: "Looks like you've skipped a few steps. Head back to the cart and try again.",
  expiredPaymentMethod: 'Please select a valid payment method.',
  giftingAlreadyExists: "We're sorry, but we can only send one gift email per order.",
  orderTotalChangedTitle: 'Your order total has changed.',
  orderTotalChanged: 'Please re-enter gift cards.',
  avsRejectedDPVCode0And2: 'The address provided could not be verified. Please review.',
  avsRejectedDPVCode3:
    'The apartment number or rural box number could not be verified. Please review.',
  avsRejectedDPVCode4: 'The apartment number or rural box number is missing. Please review.',
  avsRejectedSDDZip:
    'The address provided could not be verified. Changes to ZIP Code can be completed on Cart.',
  deleteSavedAddress: 'There was an issue deleting your address. Please try again.',
  duplicateAddress:
    'The address provided is an exact duplicate of an already saved address. Please change the name or address, or select the previously saved address to continue.',
};
